import React from "react";
import YorLoanDetails from './yourLoanDetails';
import ConfirmPage from "./confirmPage";
import { connect } from "react-redux";
import { getOfferPreFilledData } from "../../selectors";
import { storeTermsInSession } from "../../actions/crossSellApplicationActions";
import { updateStandardDataLayerAttributes, setPageNameSiteSection } from "../../analytics/adobe/index";
import { confirmDataLayer } from "../../analytics/adobe/dataLayerValues";

class BankDetailsConfirm extends React.Component {
  constructor(props) {
    super(props);
    this.state= {
      showRepeatPayments: true
    };
  }

    render = () => {
      return (
        <div className="row">
          <div className="col-lg-5 col-sm-12 col-xs-12 col-md-6 display-bank-details-flex padding-l-r-5">
            <YorLoanDetails showRepeatPayments={this.state.showRepeatPayments} offerPreFilled={this.props.offerPreFilled}/>
          </div>
          <div className="col-lg-7 col-sm-12 col-xs-12 col-md-6 display-bank-details-grid">
            <ConfirmPage {...this.props} />
          </div>
        </div>
      );
    }
}
const mapStateToProps=(state)=>({
  offerPreFilled: getOfferPreFilledData(state)
});

export default connect(mapStateToProps, { storeTermsInSession })(BankDetailsConfirm);
